module.exports = __webpack_public_path__ + "static/img/05041C_1_2_R_20201105_fit.4e8ab59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05041C_1_2_R_20201105_fit.png
// module id = sSL3
// module chunks = 0